import React, { useState, useEffect } from "react";
import { Table } from "antd";
import { Button, Card, Spin, Message } from "../BP2Components";
import {
   deleteTemplate,
   getMailTemplates,
   getSingleMailTemplate
} from "../../services/restAPI/RestApi";
import {
   setTemplateName,
   setTemplateCoverPhotoURL,
   setTemplateSubject,
   setTemplateContent,
   setNewsletterContent,
   setTemplateId,
   setTemplateSaveable,
   setTemplateIsNew
} from "../../appRedux/actions/Newsletter";
import { useDispatch } from "react-redux";
import IntlMessages from "@util/IntlMessages";

const NewsLetterList = (props) => {
   //handle delete selected rows process

   const [selectedRows, setSelectedRows] = useState([]);
   const rowSelection = {
      selectedRowKeys: selectedRows,
      onChange: (selectedRowsKeys) => {
         setSelectedRows(selectedRowsKeys);
      }
   };

   const dispatch = useDispatch();

   const [tableData, setTableData] = useState({
      totalItems: null,
      totalPages: 1,
      page: 1,
      name: "",
      columns: [
         {
            title: "No.",
            dataIndex: "id",
            key: "id",
            width: 50,
            align: "right"
         },
         { title: "Template name", dataIndex: "name", key: "name" }
      ],
      dataSource: []
   });

   const handleListResponse = (data) => {
      setTableData({
         ...tableData,
         totalItems: data?.length,
         dataSource: data
      });
   };

   useEffect(() => {
      let data = [];
      getMailTemplates().then((res) => {
         data = res.data.map((row) => {
            return {
               id: row.id,
               key: row.id,
               name: row.name,
               subject: row.subject
            };
         });
         handleListResponse(data);
      });
   }, []);

   const rowClickHandler = (record) => {
      getSingleMailTemplate(record.id)
         .then((res) => {
            dispatch(setTemplateId(record.id));
            dispatch(setTemplateName(record.name));
            dispatch(setTemplateCoverPhotoURL(res.data.coverPhotoURL));
            dispatch(setTemplateSubject(record.subject));
            dispatch(setTemplateContent(res.data.htmlContent));
            dispatch(setTemplateSaveable(false));
            dispatch(setTemplateIsNew(false));
            dispatch(
               setNewsletterContent({
                  wId: props.id,
                  subject: record.subject,
                  templateName: record.name,
                  templateId: record.id,
                  content: res.data.htmlContent,
                  coverPhotoURL: res.data.coverPhotoURL,
                  newsletterName: "",
                  newsletterId: null,
                  subscribers: null,
                  csv: null
               })
            );
            props.next();
         })
         .catch(() => Message.error("This template is unavailable."));
   };

   const deleteSelectedTemplates = (selectedRows) => {
      let counter = 0;
      let data = tableData.dataSource;
      if (selectedRows && selectedRows.length !== 0) {
         selectedRows.map((id) => {
            /* Because there is no way to fetch id of template in selected row while using Ant Design 3,
            it is needed to select <td> where id is located and get textContent from it*/
            const idCell = document.querySelector(`[data-row-key="${id}"]`).children[1];
            const templateId = Number(idCell.textContent);

            deleteTemplate(templateId)
               .then(() => {
                  Message.success(`Template ${templateId} has been deleted.`);
               })
               .catch(() =>
                  Message.error(`Template ${templateId} could not be deleted. Please refresh.`)
               );

            data = data.filter((template) => template.id !== templateId);
            counter += 1;
         });

         setTableData({
            ...tableData,
            totalItems: tableData.totalItems - counter,
            dataSource: data
         });

         setSelectedRows([]);
      }
   };

   return (
      <>
         {tableData?.totalItems !== null && tableData.totalItems >= 0 ? (
            <div className="custom-widget">
               <Button
                  buttonType="primary"
                  disabled={selectedRows.length === 0}
                  className="delete-button"
                  onClick={() => deleteSelectedTemplates(selectedRows)}
               >
                  <IntlMessages id="global.delete" />
               </Button>
               <div className="maxHScroll">
                  <Table
                     rowKey={(record) => record.ID}
                     className="gx-table-responsive newsletter-list"
                     components={tableData.component}
                     columns={tableData.columns}
                     dataSource={tableData.dataSource}
                     pagination={false}
                     size="medium"
                     rowSelection={rowSelection}
                     bordered
                     onRow={(record) => {
                        return {
                           onClick: () => rowClickHandler(record)
                        };
                     }}
                  />
               </div>
            </div>
         ) : (
            <Card className="gx-card">
               <Spin className="gx-loader-container" />
            </Card>
         )}
      </>
   );
};
export default NewsLetterList;
